import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import {StackLegacy} from '../layout/stack/stack-legacy';
import {Link} from '../link/link';
import {Metric as MetricComponent} from '../metrics/metric';
import {ReadOnlyText} from '../sms-campaigns/read-only-text';

import {getMetricDisplayValue, getMetricTitle} from './helpers';
import {StatItem} from './stat-item';
import type {Props as StatItemProps} from './stat-item';
import type {MetricKey, MetricStats} from './types';

import styles from './message-performance-list-item.module.css';

export type ListItem = {
    name: string;
    thumbnailUrl?: string;
    content?: string;
    htmlUrlPath: string;
    isDraft: boolean;
    metricKeys: MetricKey[];
    statItems: StatItemProps[];
    metricStats: MetricStats;
};

type Props = ListItem;

export function MessagePerformanceListItem(props: Props) {
    return (
        <div className={styles['message-performance-list-item']}>
            <div className={styles['left-container']}>
                {props.thumbnailUrl && (
                    <div className={styles['image-container']}>
                        <img src={props.thumbnailUrl} alt={props.name} />
                    </div>
                )}
                <div className={styles['message-info']}>
                    {/* @ts-expect-error */}
                    <Link to={props.htmlUrlPath} variant='primary' size='big' as={RouterLink}>
                        {props.name}
                    </Link>
                    {props.content && (
                        <div className='mt-8'>
                            <ReadOnlyText
                                message={props.content}
                                isFullWidth={true}
                                includeIcon={true}
                            />
                        </div>
                    )}
                    <div className={styles['stats-container']}>
                        {props.metricKeys.map((metricKey) => {
                            const value = props.metricStats[metricKey];
                            const isPercentage =
                                metricKey === 'responseRate' ||
                                metricKey === 'clickRate' ||
                                metricKey === 'openRate';

                            return (
                                <MetricComponent
                                    key={metricKey}
                                    title={getMetricTitle(metricKey)}
                                    value={getMetricDisplayValue(
                                        value,
                                        props.isDraft,
                                        false,
                                        isPercentage
                                    )}
                                    wrapWithDiv={true}
                                />
                            );
                        })}
                    </div>
                </div>
            </div>
            <div className={styles['right-container']}>
                <div
                    className={
                        props.isDraft
                            ? styles['message-performance-bars--draft']
                            : styles['message-performance-bars']
                    }
                >
                    <StackLegacy spacing={8}>
                        {props.statItems.map((statItem) => (
                            <StatItem key={statItem.nounPlural} {...statItem} />
                        ))}
                    </StackLegacy>
                </div>
            </div>
        </div>
    );
}
